import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { NAVER_AUTH_URL } from '../../../constants/config';

const Token = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const token = new URL(window.location.href).searchParams.get("token");
        const refreshToken = new URL(window.location.href).searchParams.get("refreshToken");

        if (token) {
            localStorage.setItem("token", token);
            localStorage.setItem("refreshToken", refreshToken);
            navigate('/');
        }
    }, [navigate]);

    return null;
};

export default Token;